import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './common.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'antd-mobile/dist/antd-mobile.css'
import { LanguageContextProvider } from './contexts/LanguageContext'
import { SessionProvider } from './contexts/Session'
import { HospitalBasicInfoContextProvider } from './contexts/HospitalBasicInfo'
import { OrderInfoContextProvider } from './contexts/OrderInfo'
import { OrderMarkContextProvider } from './contexts/OrderMark'
import { OrderPriceContextProvider } from './contexts/OrderPrice'
// import '@babel/polyfill'
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole

// import config from './config'
// document.title = config.titlename
ReactDOM.render(<SessionProvider>
  <HospitalBasicInfoContextProvider>
    <OrderInfoContextProvider>
      <OrderMarkContextProvider>
        <OrderPriceContextProvider>
          <LanguageContextProvider>
            <App />
          </LanguageContextProvider>
        </OrderPriceContextProvider>
      </OrderMarkContextProvider>
    </OrderInfoContextProvider>
  </HospitalBasicInfoContextProvider>
</SessionProvider>, document.getElementById('root'))
// ReactDOM.render(getRoute(), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
// 移动端调试
// let showVConsoleTimer = null
// eslint-disable-next-line
// const vConsole = new VConsole()

// document.addEventListener('touchstart', function () {
//   clearTimeout(showVConsoleTimer)
//   showVConsoleTimer = setTimeout(() => {
//     const vConsole = new VConsole()
//   }, 5000)
// })

// document.addEventListener('touchend', function () {
//   clearTimeout(showVConsoleTimer)
// })
